import { createFileRoute } from '@tanstack/react-router';

import { BuildWithUs } from '#features/careers/components/BuildWithUs';
import { staticPageHead } from '#features/static-pages/utils/head';

const title = 'Join Teamplay.gg - Build the Future of Playing Together';
const description =
  'Join Teamplay.gg to help build social LFG experiences for gamers across communities and platforms.';

export const Route = createFileRoute('/{-$locale}/_layout/build-with-us')({
  component: BuildWithUsPage,
  head: () => staticPageHead({ title, description, pathname: '/build-with-us' }),
});

function BuildWithUsPage() {
  return <BuildWithUs />;
}
